// extracted by mini-css-extract-plugin
export default {"favouriteCardActions":"Favourites_favouriteCardActions__QP13j","priceContainer":"Favourites_priceContainer__JoJ9k","priceText":"Favourites_priceText__OIO8e"};